import { NavLink} from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuth } from "../../contexts/authContext";

export const NavBar = () => {
  const { t } = useTranslation();
  const { user } = useAuth();

  const isAdmin = user?.role === "ADMIN";

  const navLinkStyles = ({ isActive }) => {
      const baseClasses = "flex-1 flex items-center justify-center h-11 text-base font-medium border-b-2 transition-colors ";
      if (isActive) {
          return `${baseClasses} border-primary text-primary`;
      } else {
        return `${baseClasses} border-transparent text-secondary hover:text-primary`;
      }
  };

  return(
    <nav className="w-full bg-white mt-10">
          <div className="mx-auto max-w-6xl px-4 sm:px-6">
             <div className="flex border-b border-secondary">
                <NavLink to="/candidates" className={navLinkStyles}>
                  {t("NAVBAR.CANDIDATES")}
                </NavLink>

                {isAdmin && (
                  <NavLink to="/users" className={navLinkStyles}>
                    {t("NAVBAR.USERS")}
                  </NavLink>
                )}
            </div>
          </div>
        </nav>
  )
}
